module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTAwIiBoZWlnaHQ9IjgwMCI+PHBhdGggZmlsbD0iI2VmMmIyZCIgZD0iTTAgMGgxMTAwdjgwMEgweiIvPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0zMDAgMGgyMDB2ODAwSDMwMHoiLz48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAzMDBoMTEwMHYyMDBIMHoiLz48cGF0aCBmaWxsPSIjMDAyODY4IiBkPSJNMzUwIDBoMTAwdjgwMEgzNTB6Ii8+PHBhdGggZmlsbD0iIzAwMjg2OCIgZD0iTTAgMzUwaDExMDB2MTAwSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/sjm.svg
// module id = VwFZ
// module chunks = 0